import React, { useState } from 'react';
import { Button, Grid, Dialog, DialogActions, DialogContent, DialogContentText, TextField, DialogTitle, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import Busy from "../../../../Busy";
import {
  requestCompleteRefundWithDeduction,
  requestCompleteRefundWithoutDeduction,
  requestDenyRefund
} from "../../../request/invoiceRequests";
import { CallbackActions } from "../../../../../util/ActionUtils";
import {getErrorMessageForStandardResponse} from "../../../../../util/NetworkErrorUtil";
import {withSnackbar} from "../../../../hocs/withSnackbar";

const RefundRequestResponseOptions = [
  {
    test: (invoice) => invoice?.locationIsLive,
    label: 'Complete Refund (Deduct From Next Payout)',
    requester: requestCompleteRefundWithDeduction,
    submitLabel: 'Approve Refund',
    success: 'Successfully completed refund! Refund Invoice: ',
    testFailure: 'Location is no longer live. Manually Invoice.'
  },
  {
    test: (invoice) => !!invoice,
    label: 'Complete Refund (DO NOT Deduct From Next Payout',
    requester: requestCompleteRefundWithoutDeduction,
    submitLabel: 'Approve Refund',
    success: 'Successfully completed refund! Refund Invoice: ',
    testFailure: ''
  },
  {
    test: (invoice) => !!invoice,
    label: 'Deny Refund',
    requester: requestDenyRefund,
    submitLabel: 'Deny Refund',
    success: 'Successfully denied refund! Refund Invoice: ',
    testFailure: ''
  },
];

const ManageRequestRefundModal = (props) => {
  const { invoice, open, onInvoiceAction, onClose, snackbarShowMessage } = props;
  const [submitLabel, setSubmitLabel] = useState('');

  const handleClose = () => {
    onClose();
  };

  const onRadioChange = (event) => {
    const index = parseInt(event.target.value);
    setSubmitLabel(RefundRequestResponseOptions[index].submitLabel);
  }

  const onSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries((formData).entries());
    const index = parseInt(formJson.refundRequestResponse);
    const requester = RefundRequestResponseOptions[index].requester;
    const reason = formJson.reason ? formJson.reason.trim() : '';

    if (!reason) {
      snackbarShowMessage('Reason is required.');
      return;
    }
    Busy.set(true);
    requester(invoice, reason).then(() => {
      onClose(CallbackActions.SUCCESS, invoice, RefundRequestResponseOptions[index].success + invoice?.transactionNumber);
    }).catch((error) => {
      onInvoiceAction(CallbackActions.ERROR, invoice, getErrorMessageForStandardResponse(error));
    }).finally(() => {
      Busy.set(false);
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        onSubmit
      }}
    >
      <DialogTitle>
        Respond to Refund Request
      </DialogTitle>
      <DialogContent>
        <RadioGroup
          name={"refundRequestResponse"}
          onChange={onRadioChange}
        >
          {RefundRequestResponseOptions.map((refundRequestResponseOption, index) => (
            <>
              <FormControlLabel
                key={refundRequestResponseOption.label}
                value={index}
                label={refundRequestResponseOption.label}
                control={<Radio disabled={!refundRequestResponseOption.test(invoice)}/>}
                error={!refundRequestResponseOption.test(invoice)}
              />
              {!refundRequestResponseOption.test(invoice) && <Typography sx={{ ml: 3.5 }} variant="subtitle2" color="error">{refundRequestResponseOption.testFailure}</Typography>}
            </>
          ))}
        </RadioGroup>
          <DialogContentText>
            Please provide an explanation.
          </DialogContentText>
          <TextField
            required
            margin="dense"
            id="outlined-multiline-static"
            name="reason"
            label="Reason for Refund"
            helperText="Enter the reason this invoice is being refunded."
            multiline
            rows={2}
            fullWidth
            variant="standard"
          />
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={"center"}>
          <Button variant="text" onClick={handleClose} >Cancel</Button>
          {invoice && submitLabel && <Button variant="contained" type="submit" >{submitLabel}</Button>}
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
export default withSnackbar(ManageRequestRefundModal);
